$(document).on("pubgm_mainsite_float_right rendered", {}, function (event, uniqueId) {
    var $this = $("#" + uniqueId);

    // console.log(event);
    // console.log(uniqueId);
    // console.log($this);
    $(".close").on("click", function () {
        $(this).toggleClass("open");
        $(".floatright__main").toggleClass("active")
    })
});